import React, { Component } from "react";
import axios from "axios";
import withRouter from "../../../Utils/withRouter";
import { ConfigContext } from "../../../Context/ConfigContext";
import Swal from "sweetalert2";
// import { saveAs } from 'file-saver';
import { TextBox } from "../../../Components/InputElements";
import { currentDateAndTime, parseQueryString } from "../../../Constants/constants";
import { NoRecords } from "../../../Components/Shimmer";

class DocumentDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      errors: {},
      employee_id: 5,
      employee_code: "TCO-TCO-099",
      loadingList: false,
      postLoading: false,
      loadingUpload: false,
      loadingFinalSubmit: false,
      documents: [],
      document_info: [],
      DownloadDocument: [],
      letters: [],
      salaries: [],
      documents_data: [],
      document_file:null,
      documentName:"",
      guest_employee_mobile_number:"",
      company_id:"",
      doc_title:"",
      doc_url:"",
      viewDocument:false,
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("data");
    if (encryptedData) {

      this.setState({
        loadingList:true,
            encryptedData:encryptedData,
            guest_employee_mobile_number: "",
            company_id: "",
       }, (prevState) => {
        this.getDecryptedData();
      });
    } else if (!encryptedData) {
      this.setState({
        encryptedData:'',
        guest_employee_mobile_number: "",
        company_id: "",
      });
    }
    
  }

 

  RemarkDocument = (employee_id, row) => {
    Swal.fire({
      title: "Submit Remark",
      input: "text",
      inputValue: row.document_remark,
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Remark cannot be empty";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_id: employee_id,
          employee_document_id: row.employee_document_id,
          document_remark: result.value,
        };

        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/RemarkDocument`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
              showConfirmButton: true,
          allowOutsideClick:false
            });
            this.GetList();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  VerifyDocument = (employee_document_id) => {
    const employee_id = this.props.params.employee_id;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Verified it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_document_id: employee_document_id,
          employee_id: employee_id,
        };
        console.log(formData);
        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/VerifyDocument`, formData, { headers })
          .then((response) => {
            console.log("response", response);
            this.GetList();
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
              showConfirmButton: true,
          allowOutsideClick:false
            });
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  UnVerifyDocument = (employee_document_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, UnVerified it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_document_id: employee_document_id,
        };

        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/UnVerifyDocument`, formData, { headers })
          .then((response) => {
            this.GetList();
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
              showConfirmButton: true,
          allowOutsideClick:false
            });
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  handleRowInputChange = (e, idx) => {
    const { value } = e.target; 
    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 
  

    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_number: value,

    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_number: "",

    };
  
    this.setState({ documents_data: updatedDocumentsData, errors: updatedErrorData },()=>{ console.log(this.state.documents_data); }); 
  };

  handleFileChange = (e,idx) => {
    const file = e.target.files[0];
    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 

    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_file: file, 
      document_number: this.state.documents_data[idx]?.document_number || this.state.rows[idx]?.employee_document_uid || "",
    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_file: "",

    };
  
    this.setState({
      document_file: file,
      documentName: file ? file.name : '',
      documents_data: updatedDocumentsData,
      errors: updatedErrorData ,
    },
      ()=>{ console.log(this.state.documents_data[idx]?.document_file?.name); });
  };

  removeFile = (idx) => {

    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 
    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_file: null,
      document_number:"", 
    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_file: "",
      document_number:"", 
    };
    this.setState({
      document_file: null,
      documentName:  '',
      documents_data: updatedDocumentsData,
      errors: updatedErrorData ,
    });
  };

  handleFileUpload = (row,idx ) => {
    console.log(this.state.documents_data);
    const errors = this.validateForm(idx);
    console.log(errors);
    if (errors[idx]?.document_file) {
      this.setState({ errors });
      return;
    }

    const fileData = this.state.documents_data[idx]?.document_file;
    const formData = {
        employee_document_id: row?.employee_document_id || null,
        date: currentDateAndTime(),
        file: fileData,
        employee_document_uid: this.state.documents_data[idx]?.document_number,
        employee_document_type_id: row?.employee_document_type_id,
      };
    // formData.append("file", file);
    // // formData.append("company_id", this.state.company_id);
    // // formData.append("guest_employee_mobile_number", this.state.guest_employee_mobile_number);
    // formData.append("employee_document_uid", this.state.documents_data[idx]?.document_number);
    // formData.append("employee_document_type_id", row?.employee_document_type_id);
    // formData.append("date", currentDateAndTime());

    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    this.setState({ loadingUpload:row?.employee_document_type_id })

    axios
      .post(
        `${apiURL}Home/EmployeeDocumentUpload`,
        formData,
        {
          params:{
            // "date": currentDateAndTime(),
            // "file": file,
            // "employee_document_uid": this.state.documents_data[idx]?.document_number,
            // "employee_document_type_id": row?.employee_document_type_id,
                company_id:this.state.company_id,
                guest_employee_mobile_number: this.state.guest_employee_mobile_number,
          },
          headers:{ 'Content-Type': 'multipart/form-data'},
        }
      )
      .then((response) => {
        const data = response.data;
        if(response.data.success===true){
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? 'Success' : 'Failed'
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false
          });
  
          this.setState({ loadingUpload:false },()=>{
            this.GetList(row?.employee_document_type_id);
          })
        }
        else{
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? 'Success' : 'Failed'
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false
          });
          this.setState({ loadingUpload:false });
        }
        
        
      })
      .catch((error) => {
        this.setState({ loadingUpload:false });
        Swal.fire({
          title: `<strong>${
             'Failed'
          }</strong>`,
          text: "Opps...! Something went wrong!",
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        });
        console.error("Error uploading file:", error);
      });
  };
  

  GetList = (id) => {
    const { apiHeaderJSON, apiURL } = this.context;
    const headers = apiHeaderJSON;
    const guest_employee_id = this.props.params.employee_id;
    axios
      .get(
        `${apiURL}Home/EmployeeCollectedData`,
        {
          params:{
            // guest_employee_id: guest_employee_id,
            company_id: this.state.company_id,
            guest_employee_mobile_number:this.state.guest_employee_mobile_number,
            date: currentDateAndTime(),
          },
          headers }
      )
      .then((response) => {
        const data = response.data;
       
        if (response.data?.success === true) {
          console.log("EmployeeCollectedData",data);

          const newDocumentsArray = data?.employee_documents_detail?.length > 0 && data?.employee_documents_detail.map((val,idx) => ({
            employee_document_type_id: val?.employee_document_type_id,
            document_file: val?.employee_document_type_id == id? null : this.state.documents_data[idx]?.document_file || null,
            document_number: this.state.documents_data[idx]?.document_number || val?.employee_document_uid || "",
          }));
          const errorArray = data?.employee_documents_detail?.length > 0 && data?.employee_documents_detail.map((val,idx) => ({
            employee_document_type_id: val?.employee_document_type_id,
            document_file: this.state.errors[idx]?.document_file || "",
            document_number: this.state.errors[idx]?.document_number ||  "",
          }));
          this.setState({
            rows: data?.employee_documents_detail || [],
            documents_data: newDocumentsArray || [],
            errors: errorArray || [],
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  getDecryptedData = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const fromData={
        encryptedData:this.state.encryptedData
    }
    axios
        .post(`${apiURL}User/DecryptData`,fromData, {headers})
        .then((response) => {
            var data = response.data;
            console.log('DecryptData',data);
            if (response.data.success === true) {
                let temp= parseQueryString(data?.decryptedData);
                console.log("tenp",temp);
                this.setState({
                  company_id:temp?.c_id,
                  guest_employee_mobile_number:temp?.mo_n,
                },()=>{
                  this.GetList();
                });
            } else {
              this.setState({
        
                loadingList: false,
              });
            }
        }).catch((error)=>{
          this.setState({
            loadingList: false,
          });
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong !!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            })
        });
};

  DownloadDocument = (employee_document_id, event) => {
    event.preventDefault();
  };

  validateForm = (idx)=>{
    const updatedDocumentsData = [...this.state.documents_data]; 

    const errors=[...this.state.errors];
    const file= this.state.documents_data[idx]?.document_file;
    // console.log(file);
    if(!file){
      errors[idx] = {
        ...errors[idx], 
        document_file: "Document is required!",
      };
      return errors;
    }

    if(file){
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf",];
      const maxFileSize = 2 * 1024 * 1024; // 2MB in bytes
      console.log(file.size);
      if (!allowedTypes.includes(file.type)) {
        errors[idx] = {
          ...errors[idx], 
          document_file: "Invalid file type. Allowed types: jpg, png, pdf.",
        };
        return errors;
      }
      else if (file.size >= maxFileSize) {
        errors[idx] = {
          ...errors[idx], 
          document_file: "File size must be less than 2MB.",
        };
        return errors;
      }
    }

    // if(!this.state.documents_data[idx]?.document_number){
    //   errors[idx] = {
    //     ...errors[idx], 
    //     document_number: "Document Number is required!",
    //   };
    //   return errors;
    // }

    return errors;

  }

  render() {
    const { rows, loadingList } = this.state;
    return loadingList? (
      <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
          <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
              </div>
          </div>
      </div>
    ) : (
      <div className="main-content">
        <div className="card">
            <div className="card-body">
                <div class="card-header  ">
                <h5>Documents Details
                  <span
                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                    *
                  </span>
                </h5>
                <p className="text-muted">
                  Fill all information below
                </p>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                      <div className="table-responsive">
                        <table className="table table-borderless table-hover align-middle mb-0">
                            <thead className="table-light">
                            <tr>
                                <th scope="col" className="text-start">
                                File Name
                                </th>
                                <th scope="col">Document Number</th>
                                {/* <th scope="col">Remark</th> */}
                                <th scope="col">Status</th>
                                <th scope="col">Upload</th>
                                {/* <th scope="col">Verified</th> */}
                            </tr>
                            </thead>
                            {rows?.length === 0?
                            <tbody>
                                <tr>
                                    <td colSpan={9}>
                                        <NoRecords/>
                                    </td>
                                </tr>
                            </tbody>:
                            <tbody>
                            {rows.map((row,idx) => (
                                <tr key={row.employee_document_type_id}>
                                    <td>
                                    <div className="d-flex align-items-center">
                                    {row.employee_document_url ? (
                                      <div
                                        onClick={() => {
                                          this.setState({
                                            doc_title:
                                              row?.employee_document_type_title,
                                            doc_url: row?.employee_document_url,
                                            viewDocument: true,
                                          });
                                        }}
                                        className="avatar-sm cursorPointer"
                                      >
                                        <div
                                          style={{ color: "blue" }}
                                          className="avatar-title text-primary bg-info-subtle text-danger rounded fs-20"
                                        >
                                          <i className="ri-eye-fill text-primary" />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="avatar-sm">
                                        <div className="avatar-title bg-danger-subtle text-danger rounded fs-20">
                                          <i className="ri-file-3-fill" />
                                        </div>
                                      </div>
                                    )}
                                      <div className="ms-3 flex-grow-1">
                                          <div className="fs-15 mb-0 text-start">
                                          <div
                                          className="text-truncate mb-0 fw-semibold"
                                          style={{
                                            maxWidth: "14rem", // Adjust max width to fit within the parent div
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            color:"rgb(68 132 255)"}}
                                            // href="#" onClick={(e) => this.DownloadDocument(row.employee_document_type_title, e)}
                                            >
                                              {row.employee_document_type_title}
                                          </div>
                                          <div
                                              style={{
                                                minWidth: "11rem", // Adjust max width to fit within the parent div
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                              }}
                                          >
                                            <div className=" d-flex align-items-center gap-1" >
                                            <h6
                                            className="text-truncate mb-0"
                                            style={{
                                              maxWidth: "11rem", // Adjust max width to fit within the parent div
                                              overflow: "hidden",
                                              whiteSpace: "nowrap",
                                              textOverflow: "ellipsis",
                                            }}> {this.state.documents_data[idx]?.document_file?.name ?this.state.documents_data[idx]?.document_file?.name : 
                                            row.employee_document_url? 
                                            row.employee_document_url?.split("/")[row.employee_document_url?.split("/")?.length-1] :"--"}</h6>
                                            {this.state.documents_data[idx]?.document_file?.name && (<button
                                                    type="button"
                                                    className="btn-close"
                                                    aria-label="Close"
                                                    onClick={()=> this.removeFile(idx)}
                                                ></button>)}
                                                </div>
                                              {/* <small className="text-muted">
                                              {row.document_remark ||
                                                  "No Remark !!"}
                                              </small> */}
                                          </div>
                                          </div>
                                      </div>
                                    </div>
                                    {this.state.errors[idx]?.document_file && ( <small className="text-danger" >{this.state.errors[idx]?.document_file} </small> )}
                                </td>
                                <td>
                                {/* <div className="d-flex align-items-center">
                                        <input
                                        type="text"
                                        id="document_number"
                                        name="document_number"
                                        label="document_number"
                                        className=" py-1 px-2"
                                        placeholder="Enter ID Number"
                                        // disabled={!this.state.documents_data[idx]?.document_file}
                                        value={this.state.documents_data[idx]?.document_number || row?.employee_document_uid}
                                        onChange={(e)=> this.handleRowInputChange(e,idx,row)}
                                        />
                                </div> */}
                                <input
                                    type="text"
                                    id="document_number"
                                    name="document_number"
                                    className="py-1 px-2"
                                    placeholder="Enter ID Number"
                                    disabled={!this.state.documents_data[idx]?.document_file}
                                    value={this.state.documents_data[idx]?.document_number || ""}
                                    onChange={(e) => this.handleRowInputChange(e, idx, row)}
                                />

                                </td>
                                {/* <td>
                                    <button
                                    type="button"
                                    className={`${row.document_status_label === "Verified" || row.document_status_label === "Pending" ? "disabled" : ""} btn btn-light btn-sm btn-label waves-effect right waves-light`}
                                    onClick={() =>
                                        this.RemarkDocument(
                                        this.state.employee_id,
                                        row
                                        )
                                    }
                                    >
                                    <i className="bx bx-info-circle label-icon align-middle fs-16 ms-2" />
                                    Remark
                                    </button>
                                </td> */}
                                <td>
                                    <span
                                    className={`badge bg-${row.document_status_color} px-3 py-2`}
                                    >
                                    {row.document_status_label}
                                    </span>
                                </td>
                                <td>
                                {!this.state.documents_data[idx]?.document_file  ?
                                <>
                                    <input
                                    type="file"
                                    id={`fileInput-${row?.employee_document_type_id}`}
                                    style={{ display: "none" }}
                                    disabled={this.state.loadingUpload}
                                    onChange={(e) =>{
                                      // console.log("document_file",this.state.documents_data[idx]?.document_file);
                                    // if(this.state.documents_data[idx]?.document_file){
                                    //   this.handleFileUpload(e, row,idx)
                                    //   console.log("handleFileUpload",this.state.documents_data[idx]?.document_file);
                                    // }
                                    // else{
                                        this.handleFileChange(e,idx)     
                                    // }
                                  }
                                    }
                                    accept="image/png, image/jpg, image/jpeg, .pdf"
                                    />
                                    {row.document_status_label === "Uploaded" ? (
                                    <>
                                        <label
                                        htmlFor={`fileInput-${row.employee_document_type_id}`}
                                        className={`btn w-100 py-2 btn-secondary btn-sm btn-label waves-effect waves-light`}
                                        >
                                        <i className="ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                        Change
                                        </label>
                                    </>
                                    ) : (
                                    <>
                                    
                                        <label
                                        htmlFor={`fileInput-${row?.employee_document_type_id}`}
                                      
                                        className={`${row.document_status_label === "Verified" ? "disabled" : ""} btn w-100 btn-${"success"} btn-sm btn-label waves-effect waves-light py-2 mb-0`}
                                        >
                                          {this.state.loadingUpload == row?.employee_document_type_id?
                                          <span class="spinner-border flex-shrink-0" role="status">
                                          <span class="visually-hidden">Loading...</span>
                                          </span>:
                                          <i className={`ri-file-upload-line label-icon align-middle fs-16 me-2`} />
                                          }
                                          {"Choose File"}
                                        </label>

                                        
                                    </>
                                    )}
                                    </>:
                                    this.state.loadingUpload == row?.employee_document_type_id?
                                    <button className="btn w-100 btn-primary btn-load"
                                    >
                                    <span className="d-flex align-items-center">
                                        <span className="spinner-border flex-shrink-0" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </span>
                                        <span className="flex-grow-1 ms-2">
                                        Uploading...
                                        </span>
                                        </span>
                                    </button>:
                                    <button
                                    onClick={()=> {
                                      console.log("document_file",this.state.documents_data[idx]?.document_file,this.state.loadingUpload);
                                        this.handleFileUpload( row,idx);
                                      }
                                      }
                                    className={`${this.state.loadingUpload? "disabled" : ""} btn w-100 btn-primary btn-label ms-auto waves-effect waves-light`}
                                >
                                    <i className="ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                    Upload
                                </button>
                                    
                                      }
                                </td>
                                {/* <td>
                                    <button
                                    type="button"
                                    className={`${row.document_status_label === "Pending" ? "disabled" : " "} btn btn-success btn-sm btn-label waves-effect right waves-light`}
                                    onClick={() => this.VerifyDocument(row.employee_document_id)} >
                                    <i className=" ri-check-double-line label-icon align-middle fs-16 ms-2" />
                                    Verify
                                    </button>

                                    {row.document_status_label === "Verified" ? (
                                    <>
                                        <button
                                        type="button"
                                        className={`${row.document_status_label ===
                                            "Pending"
                                            ? "disabled"
                                            : " "
                                            } btn btn-secondary btn-sm btn-label waves-effect right waves-light`}
                                        onClick={() =>
                                            this.UnVerifyDocument(
                                            row.employee_document_id
                                            )
                                        }
                                        >
                                        <i className="ri-close-line label-icon align-middle fs-16 ms-2" />
                                        Unverified
                                        </button>
                                    </>
                                    ) : (
                                    <>
                                        <button
                                        type="button"
                                        className={`${row.document_status_label ===
                                            "Pending"
                                            ? "disabled"
                                            : " "
                                            } btn btn-success btn-sm btn-label waves-effect right waves-light`}
                                        onClick={() =>
                                            this.VerifyDocument(row.employee_document_id, row.employee_id)
                                        }
                                        >
                                        <i className=" ri-check-double-line label-icon align-middle fs-16 ms-2" />
                                        Verify
                                        </button>
                                    </>
                                    )}
                                </td> */}
                                </tr>
                            ))}
                            </tbody>}
                        </table>
                      </div>
                      
                  </div>
                </div>
                {this.state.viewDocument && (
                    <div
                      id="myModal"
                      className="modal show"
                      tabIndex={-1}
                      style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                      }}
                      aria-labelledby="myModalLabel"
                      aria-hidden="true"
                    >
                      <div
                        className=" bg-light m-auto mt-3"
                        style={{ width: "70%" }}
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="myModalLabel">
                              Document
                            </h5>

                            <button
                              onClick={() => {
                                this.setState({
                                  viewDocument: false,
                                  doc_title: "",
                                  doc_url: "",
                                });
                              }}
                              className="btn-close"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div
                            style={{ padding: "0 10px 10px 0" }}
                            className="modal-body"
                          >
                            <div className="row">
                              <div
                                className="mb-4 m-auto p-1 rounded-2 grayBlurShadow"
                                style={{ width: "80%" }}
                              >
                                <h3 className="text-center">
                                  {this.state.doc_title}
                                </h3>
                                <div
                                  className="m-auto rounded-3 overflow-hidden"
                                  style={{
                                    width: "100%",
                                    height: "600px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {this.state.doc_url?.includes("pdf") ? (
                                    <iframe
                                      src={this.state.doc_url}
                                      title="PDF Viewer"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      frameBorder="0"
                                    >
                                      This browser does not support embedded
                                      files.
                                    </iframe>
                                  ) : (
                                    <img
                                      src={this.state.doc_url}
                                      style={{
                                        width: "100%",
                                        // height: "100%",
                                      }}
                                      alt="document_image"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              onClick={() => {
                                this.setState({
                                  viewDocument: false,
                                  doc_title: "",
                                  doc_url: "",
                                });
                              }}
                              className="btn btn-light"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
            </div>
        </div>
      </div>
    );
  }
}
export default withRouter(DocumentDetails);


